import { useEffect } from 'react';
import { useThemeData } from '@msrceng/theme';
import { useAuth } from '@msrceng/auth';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useLocalStorageThemeKey } from './useLocalStorageThemeKey';
/**
 * If the user is not logged in, and login is not in progress,
 * check for a theme in local storage, and set that as the theme.
 */
export const useEffectSetThemeFromLocalStorageWhenUnauthenticated = () => {
    const { inProgress } = useMsal();
    const { isApiTokenLoaded } = useAuth();
    const { themeKey, setTheme } = useThemeData();
    const [storageThemeKey] = useLocalStorageThemeKey();
    const isAuthIdle = inProgress === InteractionStatus.Startup ||
        inProgress === InteractionStatus.None;
    useEffect(() => {
        if (!isApiTokenLoaded && isAuthIdle) {
            // If there is no theme in local storage, do nothing.
            if (storageThemeKey === null) {
                return;
            }
            // If the theme from local storage is the same as the current theme, do nothing.
            if ((storageThemeKey === null || storageThemeKey === void 0 ? void 0 : storageThemeKey.toUpperCase()) === (themeKey === null || themeKey === void 0 ? void 0 : themeKey.toUpperCase())) {
                return;
            }
            switch (storageThemeKey) {
                case 'LIGHT':
                    setTheme('LIGHT', false);
                    break;
                case 'DARK':
                    setTheme('DARK', false);
                    break;
                default:
                    setTheme('AUTO', false);
                    // do nothing. Theme will automatically follow the OS theme
                    break;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
